import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule, IonicStorageModule],
  providers: [],
  exports: []
})
export class SharedHttpModule {}
